import React, {useEffect, useState} from "react"
import * as prosConnect from "../prodect/ProsConnect"
import {
    ATTR_EXPIRATION,
    ATTR_TEXT, UI_LISTED_ELEMENTS_LIMIT,
    getValidAttr,
    getValidInteger,
    isProsItemEqual, isValueEmpty,
    MAX_RB_OPTIONS,
    STR_NO,
    STR_NO_VALUE,
    STR_YES,
    ATTR_CREATED_BY,
    ATTR_OBJ_ID, makeObjCopyForAws, ATTR_FILE_NAME,
    ATTR_OBJ_TYPE, getActiveProject, OBJ_TYPE_ITM_OBS
} from "./ProsConnect";
import ProsDate from "./ProsDate";
import {AudioPlayer, isEnumSelectionType, ProsUpdateInfo} from "./ProsCommonUi";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Checkbox from "../components/Checkbox";
import Spacer from "../components/Spacer";
import TextInput from "../components/TextInput";
import DropdownMenu from "../components/DropdownMenu";
import BasicModal from "../components/BasicModal";
import {prosAppNotifWait} from "./ProsAppNotif";
import {USE_DEVELOPMENT_FEATURES} from "../config";
import ProsEnumMenu from "./ProsEnumMenu";
import {ATTR_EXPIRATION_REQUIRED, strToBool} from "../prodect/ProsConnect";
import ToggleSwitch from "../components/ToggleSwitch";


// Most recently selected report ID to add a new OBS.
// Gets updated when chosen from report drop down menu or when opening a report in list view.
// When project is changed last report ID would not be found and it would be set as undefined which means "not chosen".
var lastSelectedReportId = undefined

/**
 * Remember most recently selected report ID
 * @param reportId
 */
export function rememberLastSelectedReportId(reportId) {
    lastSelectedReportId = reportId
}

export function ProsEditObs({refObs, saveObs, cancelEdit, deleteObs, report, ...props}) {
    // initialAttrs is used to know if settings been changed
    // obs has current values starting from initial
    const [initialAttrs, setInitialAttrs] = useState()
    const [continueAttrs, setContinueAttrs] = useState()
    const [obs, setObs] = useState(initialAttrs)
    const [project, setProject] = useState()
    const [reportId, setReportId] = useState(report)
    const [showAll, setShowAll] = useState(getShowAllSetting())

    useEffect(() => {
        // Make a local copy from prodect item
        let project = prosConnect.getActiveProject()
        let attrs = refObs ? makeObjCopyForAws(refObs) : {[ATTR_OBJ_TYPE]: OBJ_TYPE_ITM_OBS, ...props.attrs}
        if (project) {
            setProject(project)
            const stateTag = getActiveProject().getStateRbTag()
            if (!refObs && stateTag) {
                attrs[stateTag] = getActiveProject().getDefaultState()
            }
        }
        if (continueAttrs) attrs = continueAttrs
        setObs(attrs)
        setInitialAttrs(attrs)
        if (!report) {
            let chosenReportId = undefined
            if (prosConnect.getActiveProject().getReports()
                .find(report => report[ATTR_OBJ_ID] === lastSelectedReportId)) {
                // Previous last chosen report ID found - i.e. project not changed
                // preselect same report as been used last time
                chosenReportId = lastSelectedReportId
            }
            rememberLastSelectedReportId(chosenReportId)
            setReportId(chosenReportId)
        }
    }, [refObs, report, props.attrs, continueAttrs])

    const hasPermissionToEditExpiration = prosConnect.hasPermissionTo("editExpiration", obs)
    const isDataChanged = obs && initialAttrs && !isProsItemEqual(obs, initialAttrs)

    function getShowAllSetting(){
        const localData = localStorage.getItem("editObsShowAll")
        return localData ? JSON.parse(localData) : false
    }

    function changeObsAttr(attr, val) {
        let changedObs = makeObjCopyForAws(obs)
        changedObs[attr] = val
        setObs(changedObs)
    }

    function saveEditedObsAttributes(continueAfter = false) {
        // Get txt fields
        project.getTxtTags().forEach(tag => {
            let inputField = document.getElementById(tag)
            let inputValue = inputField ? inputField.value : undefined
            if (inputValue !== undefined && obs[tag] !== inputValue) {
                obs[tag] = inputValue
            }
        })
        if (!refObs) {
            // Create new OBS
            saveObs(obs, reportId)
            if (continueAfter) {
                let newAttrs = Object.assign({}, obs)
                newAttrs[ATTR_TEXT] = ''
                newAttrs[ATTR_OBJ_ID] = null
                setContinueAttrs(newAttrs)
                prosAppNotifWait("Luodaan kirjaus")
            } else setContinueAttrs(null)

        } else {
            // Update OBS changed attributes
            let attrChanges = {
                [ATTR_OBJ_ID]: obs[ATTR_OBJ_ID],
                [ATTR_OBJ_TYPE]: obs[ATTR_OBJ_TYPE]
            }
            for (let attr of Object.keys(obs)) {
                if (getValidAttr(obs, attr, STR_NO_VALUE) !==
                    getValidAttr(initialAttrs, attr, STR_NO_VALUE)) {
                    attrChanges[attr] = obs[attr]
                }
            }
            saveObs(attrChanges)
        }
    }

    function changeObsOnOff(obs, tag, newChecked) {
        changeObsAttr(tag, newChecked ? STR_YES : STR_NO)
    }

    function getOnOffStates(chTags, onOff, tagInd) {
        if (tagInd >= chTags.length) {
            return null
        }
        const tag = chTags[tagInd]
        const isChecked = obs[tag] === STR_YES
        return <Checkbox
            key={tag}
            checked={isChecked}
            disabled={!project.getMayEditCheckBoxOrText(tag)}
            text={onOff}
            onChange={() => changeObsOnOff(obs, tag, !isChecked)}
        />
    }

    function getObsOnOffTitles(chTags) {
        return project.getChTagLabels().map((item, i) => {
            return getOnOffStates(chTags, item, i)
        })
    }

    function changeObsTag(tag, optionIndex) {
        let newVal = optionIndex.toString()
        // Multivalue can be deselected except if is a state
        if (tag !== prosConnect.getActiveProject().getStateRbTag() || obs[tag] !== newVal) {
            changeObsAttr(tag, obs[tag] !== newVal ? newVal : STR_NO_VALUE)
        }
    }

    function changeExpireTime(timeMs) {
        changeObsAttr(ATTR_EXPIRATION, timeMs)
    }

    function changeObsText(val) {
        changeObsAttr(ATTR_TEXT, val)
    }

    function renderTag(tagName, tagInd, optionIndex) {
        let tag = project.tagIndexToId(tagInd)
        let obsTagVal = prosConnect.getValidAttr(obs, tag, -1)
        let mayEditSelectedTagAndOption = project.mayEditRgTag(tagInd, optionIndex)
        let rbInd = getValidInteger(obsTagVal, -1, -1, MAX_RB_OPTIONS - 1)
        let mayEditCurrentlySelectedTagOption = project.mayEditRgTag(tagInd, rbInd)
        return <BasicButton
            key={tag + optionIndex}
            label={tagName}
            btnClass={""}
            action={() => changeObsTag(tag, optionIndex)}
            selected={optionIndex.toString() === obsTagVal}
            disabled={!(mayEditSelectedTagAndOption && mayEditCurrentlySelectedTagOption)}
        />
    }

    function getRbTagsToList(tagInd) {
        let mvTag = project.getMvTagSettings(tagInd)
        return mvTag.options.map(option => {
            if (!option.inUse) {
                return null
            }
            return renderTag(option.label, tagInd, option.optionIndex)
        })
    }

    function renderShowAll() {
        return <>
            <ToggleSwitch
                label={"Näytä vain pakolliset valinnat"}
                checked={!showAll}
                onChange={() => {
                    localStorage.setItem("editObsShowAll", JSON.stringify(!showAll))
                    setShowAll(!showAll)
                }}
            />
            <Spacer/>
        </>
    }

    function isVisibleOrNot(item, isMandatory) {
        const booleanValue = typeof isMandatory === 'boolean' ? isMandatory : strToBool(isMandatory)
        if (!booleanValue && !showAll) {
            return false
        }
        return true
    }

    function renderObsOptions() {
        let stagList = project.getRbTagTitles()
        if (stagList.length < 1) return null
        return <>
            <div className={"grid-container grid-1 grid-2_md grid-3_xl margin-top"}>
                {stagList.map((item, i) => {
                    let tag = project.getMvTagSettings(i)
                    let isAnySelected = false
                    tag.options.forEach((option, j) => {
                        let tagIndexToId = project.tagIndexToId(i)
                        let obsTagVal = prosConnect.getValidAttr(obs, tagIndexToId, -1)
                        if (obsTagVal.toString() === j.toString() && tag.inUse && option.inUse) {
                            isAnySelected = true
                        }
                    })
                    const isMandatoryAndMissing = tag.isMandatory && !isAnySelected
                    if (!isVisibleOrNot(item, tag.isMandatory) && i !== 0) return null//show if is State/Tila
                    return <div key={i}>
                        <h4>{isMandatoryAndMissing ? <span className={"display-flex color-2nd"}>
                            {item}<i
                            className={"ui-icon ui-icon-xs ui-icon-asterisk ui-icon_color-2nd"}/></span> : item}</h4>
                        <div className={"tag-list"}>
                            {getRbTagsToList(i)}
                        </div>
                    </div>
                })}
            </div>
            <Spacer size={"lg"}/>
        </>
    }

    function getObsTextFields(project) {
        let textFieldsList = project.getTxtLabels()
        if (textFieldsList.length < 1) return null
        let tags = project.getTxtTags()
        return <div className={"grid-container grid-1 grid-2_md grid-3_xl margin-top"}>
            {textFieldsList.map((label, i) => {
                if (tags.length < i) return null
                let txt = prosConnect.getValidAttr(obs, tags[i], '')
                let isMandatoryAndMissing = project.isTxtMandatory(tags[i]) && isValueEmpty(txt)
                if (!isVisibleOrNot(txt, project.isTxtMandatory(tags[i]))) return null
                return <div key={i}>
                    <GetTextFieldToList
                        index={i}
                        label={label}
                        initialText={txt}
                        disabled={!project.getMayEditCheckBoxOrText(tags[i])}
                        textFieldType={project.getTextFieldType(tags[i])}
                        onChange={txt => {
                            changeObsAttr(tags[i], txt)
                        }}
                        isMandatoryAndMissing={isMandatoryAndMissing}
                    />
                </div>
            })}
        </div>
    }

    function renderSaveAndContinueOptions(isDisabled) {
        if (refObs || isDisabled) return null
        return <BasicButton
            btnClass={"primary"}
            icon={"arrow-right"}
            label={"Tallenna ja jatka"}
            disabled={isDisabled}
            action={() => {
                saveEditedObsAttributes(true)
            }}
        />
    }

    function renderPopupFooter() {
        const isDisabled = (typeof obs[ATTR_TEXT] === 'undefined' || obs[ATTR_TEXT].length < 1)
            || !prosConnect.hasPermissionTo("editObj", obs) || !isDataChanged
        return <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                {refObs && prosConnect.hasPermissionTo("manageObj", obs) ? <ConfirmButton
                        btnClass={"2nd"}
                        label={"Poista..."}
                        icon={"bin"}
                        action={() => {
                            cancelEdit()
                            deleteObs()
                        }}
                        confirmAction
                        confirmMessage={"Voit palauttaa kirjauksen asetuksista kohdasta 'Tietojen palautus'."}
                        btnType={"fatal"}
                    />
                    : null}
                {prosConnect.isSuperUserModeInUse() || USE_DEVELOPMENT_FEATURES ?
                    <BasicButton
                        btnClass={"2nd"}
                        label={"Dump obj"}
                        icon={"search"}
                        action={() => prosConnect.dumpProsObj(obs)}
                    />
                    : null}
                <CancelButton
                    action={() => cancelEdit()}
                />
                {renderSaveAndContinueOptions(isDisabled)}
                <ConfirmButton
                    label={"Valmis"}
                    action={() => {
                        saveEditedObsAttributes()
                        cancelEdit()
                    }}
                    disabled={isDisabled}
                />
            </div>
        </footer>
    }

    function renderReportList() {
        const reports = prosConnect.getActiveProject().getReports(true)
        let reportList = reports.map(report => ({
            value: report.obj_id,
            text: prosConnect.getReportInfo(report),
        }))
        return <DropdownMenu
            values={reportList}
            currentValue={reportId}
            onSelect={(val) => {
                lastSelectedReportId = val
                setReportId(val)
            }}
            showTexts
            showFilter={reports.length > UI_LISTED_ELEMENTS_LIMIT}
            text={"Valinta puuttuu"}
            btnClass={"2nd"}
            active={reportId}
            required={!reportId}
            className={"width-100"}
        />
    }

    function isObjectEmpty(obj) {
        return Object.keys(obj).length < 1
    }

    function renderExpirationDate() {
        if (!isVisibleOrNot(ATTR_EXPIRATION_REQUIRED, project.attrs[ATTR_EXPIRATION_REQUIRED])) return null
        return <>
            <h4>Määräaika</h4>
            <div className={"tag-collection margin-top"}>
                <ProsDate
                    obs={obs}
                    timeMs={prosConnect.getExpiration(obs)}
                    isMissing={project.isExpirationDateMissing(obs)}
                    timeTitle="Määräaika"
                    useButtonTitle={hasPermissionToEditExpiration ? "Aseta" : undefined}
                    onTimeChanged={timeMs => changeExpireTime(timeMs)}
                />
            </div>
        </>
    }

    function renderOnOffSelections() {
        const chTags = project.getChTags()
        if (chTags.length < 1) return null
        return <>
            <div className={"selection-group selection-group-check grid-container grid-2 grid-3_xl flex-gap-sm"}>
                {getObsOnOffTitles(chTags)}
            </div>
            <Spacer size={"lg"}/>
        </>
    }

    function renderTagSettings() {
        const hasAudio = prosConnect.getValidAttr(obs, ATTR_FILE_NAME, STR_NO_VALUE) !== STR_NO_VALUE
        return <>
            <section className={!prosConnect.hasPermissionTo("editObj", obs) ? " disable-children" : null}>
                {refObs ? <h4 className={"title-thin"}>{refObs.ui_report || (report ? report[ATTR_TEXT] : null)}</h4>
                    : <div className={"element-set-v-sm"}><h4>Valitse raportti</h4>{renderReportList()}</div>}
                <Spacer/>
                <h4>Kirjaus</h4>
                <TextInput
                    placeholder={"Kirjoita kirjaus..."}
                    value={obs[ATTR_TEXT] ?? ""}
                    onChange={val => changeObsText(val)}
                    multiline={3}
                    isControlled
                    required
                    isValid //required needs this to work correctly, confusing? -yes.
                    disabled={!reportId}
                    data-tooltip={!prosConnect.hasPermissionTo("editObj", obs) ? "Ei oikeuksia " + (!isObjectEmpty(refObs) ? "muokata" : "lisätä") : null}
                    className={!prosConnect.hasPermissionTo("editObj", obs) ? "tooltip-active tooltip-bottom" : null}
                />
                {hasAudio && obs[ATTR_CREATED_BY] === prosConnect.getUserEmail(true) ? <AudioPlayer item={obs}/> : null}
                {renderExpirationDate()}
                <Spacer line/>
                <div className={"element-set valign-center margin-bottom"}>
                    <h3 className={"flex-grow margin-0"}>Kirjauksen valinnat</h3>
                    {renderShowAll()}
                </div>
                {renderOnOffSelections()}
                {renderObsOptions()}
                {getObsTextFields(project)}
                <ProsUpdateInfo prosObj={obs}/>
            </section>
            {renderPopupFooter()}
        </>
    }

    // Main ProsEditObs render
    if (!obs) {
        return null
    }
    return renderTagSettings()
}

export function GetTextFieldToList(props) {
    let newTxt = props.initialText
    const [txt, setTxt] = useState(props.initialText)

    useEffect(() => {
        props.onChange(txt)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[txt])

    if (isEnumSelectionType(props.textFieldType)) {
        const customButton = <BasicButton
            icon={"edit"}
            className={"text-as-button"}
            disabled={props.disabled}
            action={()=>{
                BasicModal('Muokkaa', <ProsEnumMenu
                        label={props.label}
                        txt={txt}
                        textFieldType={props.textFieldType}
                        onChange={selectedEmails =>{
                            newTxt = selectedEmails
                        }}
                        isMandatoryAndMissing={props.isMandatoryAndMissing}
                    />,
            {
                        action: ()=>{
                            setTxt(newTxt)
                        },
                        //keepWidth: true //commenting out for release
                })
            }}
        />
        return <>
            <TextInput
                label={props.label}
                placeholder={"..."}
                value={txt}
                readOnly={true}
                multiline={props.textFieldType === prosConnect.TEXT_FIELD_TYPE_EMAILS
                    && (txt.match(/@/g) || []).length > 1 ? 3 : null}//calculate email addresses and make multiline if more than 1
                customButton={customButton}
                isControlled={true}
                required={props.isMandatoryAndMissing}
                isValid={txt.length > 0}
            />
        </>
    } else {
        const isNumber = props.textFieldType === prosConnect.TEXT_FIELD_TYPE_NUMBER
        return <TextInput
            label={props.label}
            placeholder={isNumber ? "Kirjoita numero" : "Kirjoita teksti"}
            value={txt}
            multiline={isNumber ? undefined : 3}
            disabled={props.disabled}
            onChange={(val)=>setTxt(val)}
            required={props.isMandatoryAndMissing}
            isValid={txt.length > 0}
            type={isNumber ? "number" : "text"}
        />
    }
}